import React from "react";
import { Card, Skeleton } from "antd";

const LoadingApp = () => {
  const active = true;
  
  return (
    <div className="candidate-details two">
      <div className="container">
        <div className="row bg-white border py-3 align-items-center">
          <div className="col-md-2 d-flex justify-content-center">
            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton.Avatar
                style={{ width: "100px", height: "100px" }}
                active={active}
                size={"large"}
                shape={"circle"}
              />
            </div>
          </div>
          <div className="col-lg-10 my-lg-0 my-2" style={{ padding: "0 30px" }}>
            <Skeleton.Input active={active} size={"small"} block={true} />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-12 p-0">
            <Card
              className={" bg-white mb-4"}
              title={
                <Skeleton.Input
                  active={active}
                  size={"small"}
                  style={{ width: "200px" }}
                />
              }
            >
              <Skeleton.Input
                className="mb-2"
                active={active}
                size={"small"}
                block={true}
              />
              <Skeleton.Input active={active} size={"small"} block={true} />
            </Card>

            <Card
              className={" bg-white mb-4"}
              title={
                <Skeleton.Input
                  active={active}
                  size={"small"}
                  style={{ width: "200px" }}
                />
              }
            >
              <Skeleton.Input
                className="mb-2"
                active={active}
                size={"small"}
                block={true}
              />
              <Skeleton.Input active={active} size={"small"} block={true} />
            </Card>

            <div className="row">
              <div className="col-md-6">
                <Card>
                  <Skeleton.Input
                    active={active}
                    size={"small"}
                    block={true}
                    style={{ height: "200px" }}
                  />
                </Card>
              </div>
              <div className="col-md-6">
                <Card>
                  <Skeleton.Input
                    active={active}
                    size={"small"}
                    block={true}
                    style={{ height: "200px" }}
                  />
                </Card>
              </div>
            </div>
            <Card
              className={" bg-white my-4"}
              title={
                <Skeleton.Input
                  active={active}
                  size={"small"}
                  style={{ width: "200px" }}
                />
              }
            >
              <Skeleton.Input
                className="mb-2"
                active={active}
                size={"small"}
                block={true}
              />
              <Skeleton.Input active={active} size={"small"} block={true} />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingApp;
